<app-header [lang]="language"></app-header>
<div [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <router-outlet></router-outlet>
</div>
<app-footer [lang]="language"></app-footer>

<a [href]="whatsApp.link" target="_blank">
  <img [src]="whatsApp.path" class="whatsapp" alt="WhatsApp Logo" />
</a>
